const { get } = require('lodash');

export const getInfluencerAmt = (state) => get(state?.login, 'userInfo.InfluencerAmt');
